import Box from '@mui/material/Box';
import type { GuideCardData } from '../types';
import { GuideCardFront } from './card/GuideCardFront';

interface GuideIdentityCardProps {
  card: GuideCardData;
  /** Upper bound for the preview width; the card scales down proportionally below it. */
  maxWidth?: number;
}

/** On-screen landscape card preview. */
export function GuideIdentityCard({ card, maxWidth = 760 }: GuideIdentityCardProps) {
  return (
    <Box sx={{ width: '100%', maxWidth, mx: 'auto' }}>
      <GuideCardFront card={card} surface="screen" />
    </Box>
  );
}
